import { useContext } from 'react';
import { TimerContext } from '../TimerContext';

export const useTimerContext = () => {
  const context = useContext(TimerContext);
  if (!context) {
    throw new Error('useTimerContext must be used within TimerProvider');
  }
  return context;
};
